export type EnabledRequirementType =
  | "ZMENA_EMAILU"
  | "ZMENA_MOBIL_TELEFONU"
  | "ZADANISAMOODECTU"
  | "PRECHODEMAILKOMUNIKACE"
  | "ZMENAJMENAAPRIJMENI"
  | "REKLAMACE"
  | "ZMENATRVALEADRESY_SIDLASPOLECNOSTI"
  | "ZMENADISTRIBUCNISAZBY_JISTICE_REZERVOVANEHOPRIKONU"
  | "ZMENAZPUSOBUPLATBY"
  | "ZMENAZALOH"
  | "ZMENAKAPACITYPLYN"
  | "ZMENATELEFONU"
  | "ZMENAKAPACITYELEKTRINAMESICNI"
  | "ZMENAKAPACITYELEKTRINAROCNI"

export const EnabledRequirementType = {
  ZMENA_EMAILU: "ZMENA_EMAILU" as EnabledRequirementType,
  ZMENA_MOBIL_TELEFONU: "ZMENA_MOBIL_TELEFONU" as EnabledRequirementType,
  ZADANISAMOODECTU: "ZADANISAMOODECTU" as EnabledRequirementType,
  PRECHODEMAILKOMUNIKACE: "PRECHODEMAILKOMUNIKACE" as EnabledRequirementType,
  ZMENAJMENAAPRIJMENI: "ZMENAJMENAAPRIJMENI" as EnabledRequirementType,
  REKLAMACE: "REKLAMACE" as EnabledRequirementType,
  ZMENATRVALEADRESY_SIDLASPOLECNOSTI: "ZMENATRVALEADRESY_SIDLASPOLECNOSTI" as EnabledRequirementType,
  ZMENADISTRIBUCNISAZBY_JISTICE_REZERVOVANEHOPRIKONU: "ZMENADISTRIBUCNISAZBY_JISTICE_REZERVOVANEHOPRIKONU" as EnabledRequirementType,
  ZMENAZPUSOBUPLATBY: "ZMENAZPUSOBUPLATBY" as EnabledRequirementType,
  ZMENAZALOH: "ZMENAZALOH" as EnabledRequirementType,
  ZMENAKAPACITYPLYN: "ZMENAKAPACITYPLYN" as EnabledRequirementType,
  ZMENATELEFONU: "ZMENATELEFONU" as EnabledRequirementType,
  ZMENAKAPACITYELEKTRINAMESICNI: "ZMENAKAPACITYELEKTRINAMESICNI" as EnabledRequirementType,
  ZMENAKAPACITYELEKTRINAROCNI: "ZMENAKAPACITYELEKTRINAROCNI" as EnabledRequirementType
};
